import { Box, IconButton, Modal, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { Paperclip, X } from "phosphor-react";

const ACCEPT_TYPES =
  ".jpg,.jpeg,.mp4,.avi";

const modalBoxSx = {
  width: { xs: "90%", sm: 600 },
  bgcolor: "#1B1D28",
  color: "#F9F9F9",
  borderRadius: "20px",
  padding: "24px",
  outline: "none",
  boxSizing: "border-box",
};

const dropzoneSx = {
  width: "100%",
  mt: 2,
  padding: "18px",
  borderRadius: "10px",
  border: "1px dashed #606479",
  bgcolor: "#252A38",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  cursor: "pointer",
  transition: "border-color 0.2s, background-color 0.2s",
  "&:hover": {
    borderColor: "#6C65D9",
    bgcolor: "#2f3550",
  },
};

const AttachMediaModal = ({ open, onClose, onFilesSelected }) => {
  const handleFiles = (fileList) => {
    if (!fileList?.length) return;
    onFilesSelected?.(Array.from(fileList));
    onClose?.();
  };

  const handleInputChange = (event) => {
    handleFiles(event.target.files);
    event.target.value = "";
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    handleFiles(event.dataTransfer.files);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      slotProps={{
        backdrop: { sx: { backgroundColor: "rgba(0, 0, 0, 0.55)" } },
      }}
    >
      <Box sx={modalBoxSx}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ fontWeight: 500, fontSize: 24 }}>
            Attach Media
          </Typography>
          <IconButton
            onClick={onClose}
            aria-label="Close attach media"
            size="small"
            sx={{
              color: "#F9F9F9",
              "&:hover": { bgcolor: "rgba(255,255,255,0.06)" },
            }}
          >
            <X size={30} />
          </IconButton>
        </Box>

        <Box
          component="label"
          htmlFor="attach-media-input"
          sx={dropzoneSx}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: "5px",
              bgcolor: "#1B1D28",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 1.5,
            }}
          >
            <Paperclip size={24} color="#6C65D9" weight="bold" />
          </Box>
          <Typography sx={{ fontSize: 14, color: "#F9F9F9", mb: 0.75 }}>
            Attach JPG, JPEG, MP4, AVI
          </Typography>
          <Typography sx={{ fontSize: 12, color: "#B1B5C9" }}>
            Drop files here or click to upload files.
          </Typography>
        </Box>

        <input
          id="attach-media-input"
          type="file"
          multiple
          accept={ACCEPT_TYPES}
          style={{ display: "none" }}
          onChange={handleInputChange}
        />
      </Box>
    </Modal>
  );
};

AttachMediaModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onFilesSelected: PropTypes.func,
};

export default AttachMediaModal;
